export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12035.a3c9e5e8.jpg";